export default __webpack_public_path__ + "static/media/img4.e11d4e02.png";